<template>
  <div class="maps">
    <div class="heard">
      <div class="img">
        <img src="../../../assets/dapingImg/logo.png" alt />
          <!-- <div class="name">{{tenantName}}</div> -->
      </div>
      <div class="title">中物供应链平台</div>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>
    <div class="container">
      <div class="topBox">
          <el-row :gutter="12">
            <el-col :span="5">
              <div class="topBoxItem" @click="tap(0)">
                  <div class="titleA">
                      <div class="iconBox"><hr style="width:20px"><hr style="width:15px"><hr style="width:10px"></div>
                      <div class="name color1">包装业务</div>
                     <div class="iconBox" style="align-items: flex-start ;"><hr style="width:21px"><hr style="width:15px"><hr style="width:10px"></div>
                  </div>
                  <div :class="{boxA:true,active:index==0}">
                    <div class="left_h">
                      <span class="span_one">当日数据总计</span>
                    </div>
                    <div class="boxAcont">
                        <div class="itemA">
                          <p class="name color1">{{topData.pack_currPackNum}}</p>
                          <p class="name1">包装量(吨)</p>
                        </div>
                    </div>
                  </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="topBoxItem" @click="tap(1)">
                  <div class="titleA">
                      <div class="iconBox iconBox2"><hr style="width:20px"><hr style="width:15px"><hr style="width:10px"></div>
                      <div class="name color2">汽运业务</div>
                     <div class="iconBox iconBox2" style="align-items: flex-start ;"><hr style="width:21px"><hr style="width:15px"><hr style="width:10px"></div>
                  </div>
                  <div :class="{boxA:true,active:index==1}">
                    <div class="left_h">
                      <span class="span_one">当日数据总计</span>
                    </div>
                    <div class="boxAcont">
                        <div class="itemA">
                          <p class="name color2">{{topData.car_dailyWeight}}</p>
                          <p class="name1">发运量(吨)</p>
                        </div>
                        <div class="itemA">
                          <p class="name color2">{{topData.car_dailyCar}}</p>
                          <p class="name1">发车次(次)</p>
                        </div>
                    </div>
                  </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="topBoxItem" @click="tap(2)">
                  <div class="titleA">
                      <div class="iconBox iconBox3"><hr style="width:20px"><hr style="width:15px"><hr style="width:10px"></div>
                      <div class="name color3">海运业务</div>
                     <div class="iconBox iconBox3" style="align-items: flex-start ;"><hr style="width:21px"><hr style="width:15px"><hr style="width:10px"></div>
                  </div>
                  <div :class="{boxA:true,active:index==2}">
                    <div class="left_h">
                      <span class="span_one">当日数据总计</span>
                    </div>
                    <div class="boxAcont">
                        <div class="itemA">
                          <p class="name color3">{{topData.ship_currUpTotal}}</p>
                          <p class="name1">装船量(吨)</p>
                        </div>
                        <div class="itemA">
                          <p class="name color3">{{topData.ship_currDownTotal}}</p>
                          <p class="name1">卸船量(吨)</p>
                        </div>
                    </div>
                  </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="topBoxItem" @click="tap(3)">
                  <div class="titleA">
                      <div class="iconBox iconBox4"><hr style="width:20px"><hr style="width:15px"><hr style="width:10px"></div>
                      <div class="name color4">仓储业务</div>
                     <div class="iconBox iconBox4" style="align-items: flex-start ;"><hr style="width:21px"><hr style="width:15px"><hr style="width:10px"></div>
                  </div>
                  <div :class="{boxA:true,active:index==3}">
                    <div class="left_h">
                      <span class="span_one">当日数据总计</span>
                    </div>
                    <div class="boxAcont">
                        <div class="itemA">
                          <p class="name color4">{{topData.warehouse_dateComeNum}}</p>
                          <p class="name1">入库量(吨)</p>
                        </div>
                        <div class="itemA">
                          <p class="name color4">{{topData.warehouse_dateOutNum}}</p>
                          <p class="name1">出库量(吨)</p>
                        </div>
                    </div>
                  </div>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="topBoxItem" >
                  <div class="titleA">
                      <div class="iconBox iconBox5"><hr style="width:20px"><hr style="width:15px"><hr style="width:10px"></div>
                      <div class="name color5">加工业务</div>
                     <div class="iconBox iconBox5" style="align-items: flex-start ;"><hr style="width:21px"><hr style="width:15px"><hr style="width:10px"></div>
                  </div>
                  <div :class="{boxA:true,active:index==4}">
                    <div class="left_h">
                      <span class="span_one">当日数据总计</span>
                    </div>
                    <div class="boxAcont">
                        <div class="itemA">
                          <p class="name color5">敬请期待</p>
                          <!-- <p class="name1">当日包装量</p> -->
                        </div>
                    </div>
                  </div>
              </div>
            </el-col>
          </el-row>
      </div>
      <div class="bottomBox">
        <el-carousel ref="carousel" indicator-position="none" @change="change"  :autoplay="true" arrow="never" interval="30000"   >
          <el-carousel-item >
            <baozhuang v-if="index==0"></baozhuang>
          </el-carousel-item>
          <el-carousel-item  >
            <qiyun v-if="index==1"></qiyun>
          </el-carousel-item>
          <el-carousel-item >
            <haiyun v-if="index==2"></haiyun>
          </el-carousel-item>
          <el-carousel-item >
            <cangchu v-if="index==3"></cangchu>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import { dailyAndHistoryTotal } from '@/api/data-center-server'
import baozhuang from '@/views/data-center-server/zwSupplyDp/baozhuang.vue'
import qiyun from '@/views/data-center-server/zwSupplyDp/qiyun.vue'
import haiyun from '@/views/data-center-server/zwSupplyDp/haiyun.vue'
import cangchu from '@/views/data-center-server/zwSupplyDp/cangchu.vue'
export default {
  components: {
    baozhuang,
    qiyun,
    haiyun,
    cangchu
  },
  data () {
    return {
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      nowTimer: null,
      mapTimer: null,
      index: 0,
      topData: {}

    }
  },
  created () {
    this.getDate()
    this.nowTimer = setInterval(this.getDate, 500)
    this.mapTimer = setInterval(this.getTopData, 1000 * 30)
    this.getTopData()
  },
  mounted () {

  },
  methods: {
    // 获取顶部数据
    getTopData () {
      dailyAndHistoryTotal().then(res => {
        this.topData = res
      })
    },
    change (index) {
      this.index = index
    },
    tap (n) {
      this.$refs.carousel.setActiveItem(n)
    },
    // 获取当前时间
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  },
  computed: {

  },
  filters: {

  },
  destroyed () {
    clearInterval(this.nowTimer)
    clearInterval(this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.bottomBox{
  height:  calc(71vh - 12px);
  width: 100%;
  margin-top: 12px;
  /deep/.el-carousel {
    height:  calc(100% - 12px);
    .el-carousel__container{
     height:  100%;
    }
  }
}
.active{
  border:1px solid #03faec !important;
}
.topBox{
  height: 20vh;
   /deep/.el-row{
     height: 100%;
     display: flex;
     .el-col{
      height: 100%;
    }
  }
  .topBoxItem{
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .titleA{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    .name{
      font-size: 20px;
      margin: 0 4px;
    }
    .iconBox{
      display: flex;
      flex-direction:column;
      align-items: flex-end ;
      hr{
        border: none;
        border-top: 2px solid #03faec;
        margin: 0;
        margin-top: 3px;
      }
    }
    .iconBox2{
      hr{
        border-top: 2px solid #ffa500;
      }
    }
    .iconBox3{
      hr{
        border-top: 2px solid #4df442;
      }
    }
    .iconBox4{
      hr{
        border-top: 2px solid #2e9cfd;
      }
    }
    .iconBox5{
      hr{
        border-top: 2px solid #fffc0d;
      }
    }
  }

}
.boxA{
    width: 100%;
    flex: 1;
    box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75) inset;
    display: flex;
    flex-direction: column;
    border: 1px solid #045f59;
    .boxAcont{
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex: 1;
      text-align: center;
      .name{
        font-size: 24px;
        margin-bottom: 10px;
      }
      .name1{
        color: #ffffff;
        font-size: 12px;
      }
      p{
        margin: 0;
      }
    }
}
.left_h {
  height: 40px;
  line-height: 40px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: rgba(41, 139, 208, 0.3);
  box-shadow: -8px 16px 62px -18px rgba(18,102,210,0.75);
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}
.color1{
    color: #03faec;
}
.color2{
    color: #ffa500;
}
.color3{
    color: #4df442;
}
.color4{
    color: #2e9cfd;
}
.color5{
    color: #fffc0d;
}
.heard {
  width: 100%;
  height: 7vh;
  line-height: 6vh;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  // background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  justify-content: space-between;
  align-items: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    display: flex;
    .name{
      color: #03faec;
      margin-bottom: 20px;
      margin-left: 10px;
    }
    img{
      height: 100%;
    }
  }
}
.maps {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background:url('../../../assets/dapingImg/bg.png') 100%;

}
/*左右固定，中间自适应  利用绝对定位*/
.container {
  width: 100%;
  height: 91vh;
  box-sizing: border-box;
  position: relative;
  padding:12px;
}

</style>
